import {ApiErrorResponseDataError} from './api-error-response-data-error';

export class ApiErrorResponseData {
    public error: ApiErrorResponseDataError;
    public result: string;

    constructor(apiErrorResponseData?: ApiErrorResponseData) {
        this.error = apiErrorResponseData && apiErrorResponseData.error || new ApiErrorResponseDataError();
        this.result = apiErrorResponseData && apiErrorResponseData.result || null;
    }
}
